import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const customBookingFormEntity: Entity = {
  model: model,
  repository: repository,
}

export default customBookingFormEntity
